// Tokens sourced from: https://www.figma.com/design/XywPtdA1UtqQAwJTFolrBB/CR-Assess-R3?node-id=474-107940&m=dev
import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const assessVisualizerTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      layoutbackground: theme.color.surface[4],
      button: {
        color: theme.color.text.core['-primary'],
      },
      axis: {
        backgroundColor: theme.color.surface[2],
        labelColor: theme.color.text.core['-secondary'],
      },
      tools: {
        backgroundColor: theme.color.surface[3],
        boxShadow: '0px 4px 4px 0px #0000000d',
        labelColor: theme.color.text.core['-tertiary'],
      },
      legend: {
        backgroundColor: theme.color.dataVis.core['surface-0'],
        rawColor: theme.color.text.core['-secondary'],
        predictedColor: theme.color.text.core['-secondary'],
        labelColor: theme.color.text.core['-secondary'],
      },
      accordion: {
        titleBackground: theme.color.surface[2],
        backgroundColor: theme.color.surface[1],
        backgroundColorOdd: theme.color.grid.base,
        chartBackgroundColorOdd: theme.color.dataVis.core['surface-0'],
        backgroundColorEven: theme.color.grid.stripe,
        chartBackgroundColorEven: theme.color.grid.stripe,
        modelHeaderBackground: theme.color.grid.stripe,
        borderColor: theme.color.surface[4],
        titleColor: theme.color.text.core['-primary'],
        iconColor: theme.color.text.core['-secondary'],
      },
      resize: {
        handleBackground: theme.color.surface[2],
      },
      tag: {
        nameColor: theme.color.text.core['-secondary'],
        tagBackground: theme.color.surface[2],
        descriptionColor: theme.color.text.core['-primary'],
        uomColor: theme.color.text.core['-secondary'],
      },
      searchMode: {
        bannerBorderColor: theme.color.focus[5],
        bannerBackgroundColor: theme.color.surface[0],
        bannerTitleColor: theme.color.text.core['-primary'],
        bannerIconColor: theme.color.text.core['-secondary'],
      },
    },
  ]),
);
